import Icon from 'icons/Icon';
import React, { Component, ReactNode } from 'react';

class TrackerSidebarComponent extends Component<Props> {
  private divRef: HTMLDivElement | null = null;

  public render() {
    const { title, content, icon, visible, onHide } = this.props;
    return (
      <div
        ref={(r) => (this.divRef = r)}
        className={`h-full absolute right-0 top-0 bg-[#D9D9D94D]/30 flex items-center default-shadow ease-in-out duration-700 transition-all justify-end ${visible ? 'lg:w-[500px] w-full opacity-100 z-1' : 'w-0 opacity-0 z-0'}`}
      >
        <div className={'flex flex-col w-[500px] h-full bg-white gap-y-1 overflow-y-auto border '}>
          <div className={'flex justify-between px-3 items-center w-full sticky top-0 border-b min-h-[51px] h-[51px] bg-[#F7F8FA]'}>
            <div className={'flex w-full gap-x-1 h-full items-center'}>
              <Icon icon={icon} size={16} className={'text-primary'} />
              <div className={'text-center text-md text-primary'}>{title}</div>
            </div>
            <div className={'flex items-center'} onClick={onHide}>
              <Icon
                icon={'multiplier'}
                size={24}
                className={'text-primary hover:bg-primary rounded hover:cursor-pointer hover:text-white'}
                onClick={() => onHide}
              />
            </div>
          </div>
          <div className={'flex w-full h-full overflow-scroll px-5 py-5'}>{content ? content : <div>There is no content.</div>}</div>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: any) => {
    const { closable } = this.props;
    if (!closable) return;
    if (this.divRef && !this.divRef.contains(event.target)) {
    }
  };
}

interface Props {
  icon: string;
  title?: string;
  content?: ReactNode;
  visible?: boolean;
  onHide: () => void;
  closable?: boolean;
}

export default TrackerSidebarComponent;
